import { useQueryClient } from '@tanstack/react-query';

import {
	ACTIVE_ALARMS,
	ACTIVE_ALARMS_ORAN,
	ALARM_HISTORY,
	ALARM_LIST,
	ALARM_LIST_ORAN,
	HISTORY_ALARMS_ORAN,
} from '@constants/queryKeys';

const useInvalidateAlarms = () => {
	const queryClient = useQueryClient();

	const invalidateAlarms = () => {
		return [
			queryClient.invalidateQueries([ALARM_LIST]),
			queryClient.invalidateQueries([ACTIVE_ALARMS]),
			queryClient.invalidateQueries([ACTIVE_ALARMS_ORAN]),
			queryClient.invalidateQueries([HISTORY_ALARMS_ORAN]),
			queryClient.invalidateQueries([ALARM_HISTORY]),
			queryClient.invalidateQueries([ALARM_LIST_ORAN]),
		];
	};

	return {
		invalidateAlarms,
	};
};

export default useInvalidateAlarms;
